<template>
  <div
    class="spinner"
    :class="[
      isWhite ? 'spinner-white' : 'spinner-black'
    ]"
  >
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<script>
export default {
  name: 'Spinner',
  props: {
    isWhite: {
      default: false,
    },
  },
}
</script>

<style scoped>
.spinner {
  position: relative;
  width: 16px;
  height: 16px;
}
.spinner div {
  transform-origin: 8px 8px;
  animation: spinner 1.2s linear infinite;
}
.spinner div:after {
  content: ' ';
  display: block;
  position: absolute;
  top: -1px;
  left: 7px;
  width: 2px;
  height: 3px;
  border-radius: 2px;
}
.spinner-black div:after {
    background: #000000;
}
.spinner-white div:after {
    background: #FFFFFF;
}
.spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
